module.exports = __webpack_public_path__ + "img/blob2.2965fada.svg";